import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { workloadsAlertsPaths, workloadsPaths } from './paths';

const { AlertDetailsView } = lazyImport(() => import('../views/alertDetails'), 'AlertDetailsView');
const { WorkloadsView } = lazyImport(() => import('../views/workloads'), 'WorkloadsView');
const { WorkloadsAlertView } = lazyImport(() => import('../views/workloadsAlerts'), 'WorkloadsAlertView');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const workloadsRoutes: RouteObject[] = [
  {
    path: workloadsPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <WorkloadsView /> },
      { path: workloadsPaths.alertDetails.relative, element: <AlertDetailsView /> },
    ],
  },
  {
    path: workloadsAlertsPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <WorkloadsAlertView /> },
      { path: workloadsAlertsPaths.alertDetails.relative, element: <AlertDetailsView /> },
    ],
  },
];
